import { MDBIcon } from "mdbreact";
import handleCurrency from "../../../components/CurrencyFormat";
import formatDateTimeWIB from "../../../helpers/formatDateTimeWib";

export default function DataPendingInvoice({ row, onBundleClick }) {
  const checkoutLink =
    row.link?.match(/\]\((https?:\/\/[^)]+)\)/)?.[1] || row.link;

  return (
    <tr>
      <td>{row.orderId || "-"}</td>
      <td>
        {row.isBundle ? (
          <button
            type="button"
            className="btn btn-link p-0 font-weight-bold"
            onClick={() => onBundleClick(row.invoiceList || [])}
            style={{ color: "#0f6170", textDecoration: "underline" }}
          >
            {row.invoiceNo || "-"}
          </button>
        ) : (
          row.invoiceNo || "-"
        )}
      </td>
      <td>{`${row.currencyCode || ""} ${handleCurrency(row.amount)}`}</td>
      <td>
        {formatDateTimeWIB(row.paymentExpired, "DD MMM YYYY HH:mm:ss [WIB]")}
      </td>
      <td>{row.statusName || row.statusCode || "-"}</td>
      <td>
        <div className="d-flex justify-content-center align-items-center">
          {checkoutLink ? (
            <a
              href={checkoutLink}
              target="_blank"
              rel="noopener noreferrer"
              className="action-button"
            >
              <MDBIcon
                icon="external-link-alt"
                size="lg"
                className="white-text"
              />
            </a>
          ) : (
            "-"
          )}
        </div>
      </td>
    </tr>
  );
}
